import React, { useState, Component } from 'react';
import { SearchIcon, FilterIcon, GlobeIcon, MapPinIcon, CalendarIcon, ClockIcon, ArrowUpIcon, ArrowDownIcon, ArrowUpDownIcon, InfoIcon, XIcon, ActivityIcon, BarChart2Icon, FileTextIcon, LineChartIcon, PieChartIcon, UserIcon, MailIcon, PhoneIcon, TagIcon, UserCheckIcon, EyeIcon, CheckCircleIcon, XCircleIcon, ThumbsUpIcon, ThumbsDownIcon, RefreshCwIcon, ArrowRightIcon, ChevronRightIcon, MousePointerIcon, ExternalLinkIcon, CheckIcon, UserPlusIcon, PencilIcon, StarIcon, HelpCircleIcon, ClipboardIcon, TimerIcon, ThermometerIcon, SnowflakeIcon, BanIcon, UsersIcon, TrendingUpIcon, TrendingDownIcon, PercentIcon, SlackIcon, SlashIcon, SlidersIcon, UserMinusIcon, BriefcaseIcon, TargetIcon, FilterXIcon, ChevronDownIcon, CheckSquareIcon, CalendarRangeIcon, ChevronUpIcon } from 'lucide-react';
import { DashboardCard } from './DashboardCard';
// Función para formatear fechas
const formatDate = dateString => {
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };
  return new Date(dateString).toLocaleDateString('es-ES', options);
};
// Componente para mostrar la puntuación de lead con color según el valor
function LeadScoreBadge({
  score
}) {
  let color;
  if (score >= 80) {
    color = 'bg-green-500/20 text-green-400';
  } else if (score >= 60) {
    color = 'bg-blue-500/20 text-blue-400';
  } else if (score >= 40) {
    color = 'bg-amber-500/20 text-amber-400';
  } else {
    color = 'bg-red-500/20 text-red-400';
  }
  return <div className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${color}`} data-id="element-1065">
      <PieChartIcon size={12} className="mr-1" data-id="element-1066" />
      {score}
    </div>;
}
export function LeadInsightsOverview() {
  return <div className="space-y-6" data-id="element-1067">
      <PublicUsersSection data-id="element-1068" />
    </div>;
}
function PublicUsersSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [selectedActivity, setSelectedActivity] = useState('all');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [showScoreInfo, setShowScoreInfo] = useState(null);
  // Añadir estado para filtrar por estado de calificación
  const [selectedLeadStatus, setSelectedLeadStatus] = useState('all');
  // Add sort state
  const [sortField, setSortField] = useState('score');
  const [sortDirection, setSortDirection] = useState('desc');
  // Nuevos estados para filtros adicionales
  const [scoreRange, setScoreRange] = useState([0, 100]);
  const [selectedCountry, setSelectedCountry] = useState('all');
  const [dateRange, setDateRange] = useState({
    start: null,
    end: null
  });
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  // Mock data for public users - convertido a useState para poder modificarlo
  const [publicUsers, setPublicUsers] = useState([{
    id: 1,
    name: 'Carlos Mendoza',
    email: 'cmendoza@agritech-solutions.com',
    phone: '+52 555 1234 5678',
    company: 'AgriTech Solutions',
    country: 'Mexico',
    region: 'LATAM',
    registrationDate: '2025-06-10',
    lastActive: '2025-07-15',
    designs: 12,
    quotes: 3,
    score: 87,
    scoreComponents: {
      engagement: 92,
      activity: 85,
      designQuality: 88,
      quoteRequests: 75,
      marketPotential: 95
    },
    status: 'active',
    usageFrequency: 'High',
    usageDays: [true, false, true, true, false, false, true],
    usageStats: {
      lastWeek: 5,
      lastMonth: 18,
      total: 42
    },
    tags: ['High Potential', 'Irrigation'],
    leadStatus: 'new',
    notes: 'Shows consistent interest in pivot irrigation systems'
  }, {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sjohnson@farmequip.co.nz',
    phone: '+64 21 987 6543',
    company: 'Farm Equipment Solutions',
    country: 'New Zealand',
    region: 'ANZ',
    registrationDate: '2025-05-22',
    lastActive: '2025-07-14',
    designs: 8,
    quotes: 2,
    score: 74,
    scoreComponents: {
      engagement: 70,
      activity: 75,
      designQuality: 78,
      quoteRequests: 65,
      marketPotential: 80
    },
    status: 'active',
    usageFrequency: 'Medium',
    usageDays: [true, true, false, true, true, false, false],
    usageStats: {
      lastWeek: 3,
      lastMonth: 12,
      total: 28
    },
    tags: ['Medium Potential'],
    leadStatus: 'new',
    notes: 'Interested in linear systems'
  }, {
    id: 3,
    name: 'Ahmed Al-Farsi',
    email: 'ahmed@desert-irrigation.ae',
    phone: '+971 50 123 4567',
    company: 'Desert Irrigation Technologies',
    country: 'United Arab Emirates',
    region: 'MENA',
    registrationDate: '2025-07-01',
    lastActive: '2025-07-16',
    designs: 15,
    quotes: 5,
    score: 92,
    scoreComponents: {
      engagement: 95,
      activity: 90,
      designQuality: 92,
      quoteRequests: 88,
      marketPotential: 98
    },
    status: 'active',
    usageFrequency: 'Very High',
    usageDays: [true, true, true, true, true, true, false],
    usageStats: {
      lastWeek: 6,
      lastMonth: 24,
      total: 35
    },
    tags: ['High Potential', 'VIP'],
    leadStatus: 'qualified',
    notes: 'Looking for comprehensive irrigation solutions for large farms'
  }, {
    id: 4,
    name: 'João Silva',
    email: 'jsilva@agro-brasil.com.br',
    phone: '+55 11 98765 4321',
    company: 'Agro Brasil Equipamentos',
    country: 'Brazil',
    region: 'LATAM',
    registrationDate: '2025-06-15',
    lastActive: '2025-07-10',
    designs: 5,
    quotes: 1,
    score: 65,
    scoreComponents: {
      engagement: 60,
      activity: 65,
      designQuality: 70,
      quoteRequests: 55,
      marketPotential: 75
    },
    status: 'active',
    usageFrequency: 'Medium',
    usageDays: [false, true, false, true, true, false, false],
    usageStats: {
      lastWeek: 2,
      lastMonth: 8,
      total: 15
    },
    tags: ['Medium Potential'],
    leadStatus: 'new',
    notes: 'Primarily interested in corner systems'
  }, {
    id: 5,
    name: 'Marie Dupont',
    email: 'mdupont@agri-solutions.fr',
    phone: '+33 6 12 34 56 78',
    company: 'Agri-Solutions France',
    country: 'France',
    region: 'EUROPE',
    registrationDate: '2025-05-05',
    lastActive: '2025-06-20',
    designs: 3,
    quotes: 0,
    score: 42,
    scoreComponents: {
      engagement: 40,
      activity: 35,
      designQuality: 50,
      quoteRequests: 25,
      marketPotential: 60
    },
    status: 'inactive',
    usageFrequency: 'Low',
    usageDays: [true, false, false, false, true, false, false],
    usageStats: {
      lastWeek: 0,
      lastMonth: 2,
      total: 8
    },
    tags: ['Low Potential'],
    leadStatus: 'disqualified',
    notes: 'Limited engagement, no recent activity'
  }]);
  // Datos para paneles de resumen
  const summaryData = {
    totalUsers: publicUsers.length,
    activeUsers: publicUsers.filter(user => user.status === 'active').length,
    newUsersThisMonth: 3,
    leadsByStatus: {
      hot: publicUsers.filter(user => user.leadStatus === 'qualified').length,
      warm: publicUsers.filter(user => user.leadStatus === 'new').length,
      cold: publicUsers.filter(user => user.leadStatus === 'disqualified').length,
      unclassified: publicUsers.filter(user => user.leadStatus === 'unclassified').length
    },
    averageScore: Math.round(publicUsers.reduce((acc, user) => acc + user.score, 0) / publicUsers.length),
    conversionRate: 24,
    topRegion: 'LATAM',
    growthRate: 12 // Simulado (porcentaje)
  };
  // Lista de países únicos para el filtro
  const uniqueCountries = [...new Set(publicUsers.map(user => user.country))];
  const handleViewDetails = user => {
    setSelectedUser(user);
    setShowUserDetails(true);
  };
  const handleCloseDetails = () => {
    setShowUserDetails(false);
    setSelectedUser(null);
  };
  // Tooltip state
  const [tooltipVisible, setTooltipVisible] = useState(null);
  // Actualizar la función para manejar la calificación/descalificación de leads
  const handleQualifyLead = status => {
    // Actualizar el estado del lead en el array de usuarios
    const updatedUsers = publicUsers.map(user => {
      if (user.id === selectedUser.id) {
        return {
          ...user,
          leadStatus: status
        };
      }
      return user;
    });
    setPublicUsers(updatedUsers);
    // Actualizar el usuario seleccionado para reflejar el cambio en el modal
    setSelectedUser({
      ...selectedUser,
      leadStatus: status
    });
    // Mostrar mensaje de confirmación
    const statusMessages = {
      qualified: 'Lead qualified as Hot (ready to purchase)',
      disqualified: 'Lead qualified as Cold (low activity or intention)',
      new: 'Lead qualified as Warm (interested, needs follow-up)',
      unclassified: 'Lead unclassified (no classification)'
    };
    // En una aplicación real, aquí enviaríamos los datos al servidor
    console.log(`Lead ${selectedUser.id} marked as ${status}: ${statusMessages[status]}`);
  };
  const toggleScoreInfo = userId => {
    if (showScoreInfo === userId) {
      setShowScoreInfo(null);
    } else {
      setShowScoreInfo(userId);
    }
  };
  // Add sort handler
  const handleSort = field => {
    if (sortField === field) {
      // If already sorting by this field, toggle direction
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // If sorting by a new field, default to descending
      setSortField(field);
      setSortDirection('desc');
    }
  };
  // Manejador para reset de filtros
  const handleResetFilters = () => {
    setSearchQuery('');
    setSelectedRegion('all');
    setSelectedActivity('all');
    setSelectedLeadStatus('all');
    setSelectedCountry('all');
    setScoreRange([0, 100]);
    setDateRange({
      start: null,
      end: null
    });
  };
  // Filter users based on search and filters
  const filteredUsers = publicUsers.filter(user => {
    const matchesSearch = searchQuery === '' || user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase()) || user.company.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesRegion = selectedRegion === 'all' || user.region === selectedRegion;
    const matchesActivity = selectedActivity === 'all' || selectedActivity === 'active' && user.status === 'active' || selectedActivity === 'inactive' && user.status === 'inactive';
    // Filtrar por estado de calificación
    const matchesLeadStatus = selectedLeadStatus === 'all' || user.leadStatus === selectedLeadStatus;
    // Filtrar por país
    const matchesCountry = selectedCountry === 'all' || user.country === selectedCountry;
    // Filtrar por rango de puntuación
    const matchesScoreRange = user.score >= scoreRange[0] && user.score <= scoreRange[1];
    // Filtrar por rango de fechas
    let matchesDateRange = true;
    if (dateRange.start && dateRange.end) {
      const userDate = new Date(user.registrationDate);
      const startDate = new Date(dateRange.start);
      const endDate = new Date(dateRange.end);
      matchesDateRange = userDate >= startDate && userDate <= endDate;
    }
    return matchesSearch && matchesRegion && matchesActivity && matchesLeadStatus && matchesCountry && matchesScoreRange && matchesDateRange;
  });
  // Sort filtered users
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    if (sortField === 'score') {
      return sortDirection === 'asc' ? a.score - b.score : b.score - a.score;
    } else if (sortField === 'name') {
      return sortDirection === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
    } else if (sortField === 'registrationDate') {
      const dateA = new Date(a.registrationDate);
      const dateB = new Date(b.registrationDate);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'lastActive') {
      const dateA = new Date(a.lastActive);
      const dateB = new Date(b.lastActive);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'designs') {
      return sortDirection === 'asc' ? a.designs - b.designs : b.designs - a.designs;
    }
    return 0;
  });
  // Añadir estado para controlar qué descripción larga se muestra
  const [showLongDescription, setShowLongDescription] = useState(null);
  // Función para renderizar el indicador de estado del lead con la nueva escala
  const renderLeadStatusBadge = status => {
    switch (status) {
      case 'qualified':
        return <span className="bg-red-500/20 text-red-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`hot-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1069">
            <div size={12} className="mr-1" data-id="element-1070" />
            Hot lead
            {tooltipVisible === `hot-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1071">
                Ready to purchase
              </div>}
          </span>;
      case 'disqualified':
        return <span className="bg-blue-500/20 text-blue-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`cold-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1072">
            <SnowflakeIcon size={12} className="mr-1" data-id="element-1073" />
            Cold lead
            {tooltipVisible === `cold-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1074">
                Low activity or intention
              </div>}
          </span>;
      case 'new':
        return <span className="bg-amber-500/20 text-amber-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`warm-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1075">
            <ThermometerIcon size={12} className="mr-1" data-id="element-1076" />
            Warm lead
            {tooltipVisible === `warm-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1077">
                Interested, needs follow-up
              </div>}
          </span>;
      case 'unclassified':
        return <span className="bg-slate-500/20 text-slate-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`unclassified-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1078">
            <BanIcon size={12} className="mr-1" data-id="element-1079" />
            Unclassified
            {tooltipVisible === `unclassified-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1080">
                Lead with no assigned classification
              </div>}
          </span>;
      default:
        return <span className="bg-slate-500/20 text-slate-400 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-1081">
            <BanIcon size={12} className="mr-1" data-id="element-1082" />
            Unclassified
          </span>;
    }
  };
  // Función para mostrar/ocultar la descripción larga
  const toggleLongDescription = id => {
    if (showLongDescription === id) {
      setShowLongDescription(null);
    } else {
      setShowLongDescription(id);
    }
  };
  return <>
      {/* Paneles de resumen */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6" data-id="element-1083">
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1084">
          <div className="flex justify-between items-start mb-4" data-id="element-1085">
            <div className="p-2 rounded-lg bg-blue-500/20" data-id="element-1086">
              <UsersIcon size={20} className="text-blue-400" data-id="element-1087" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-green-500/20 text-green-400" data-id="element-1088">
              <ArrowUpIcon size={12} className="mr-1" data-id="element-1089" />
              {summaryData.growthRate}%
            </div>
          </div>
          <div className="flex justify-between items-end" data-id="element-1090">
            <div data-id="element-1091">
              <div className="text-sm text-slate-400 mb-1" data-id="element-1092">Public Users</div>
              <div className="text-2xl font-bold text-white" data-id="element-1093">
                {summaryData.totalUsers}
              </div>
              <div className="text-xs text-blue-400 mt-1" data-id="element-1094">
                {summaryData.activeUsers} active
              </div>
            </div>
            <div className="text-right" data-id="element-1095">
              <div className="text-xs text-slate-400 mb-1" data-id="element-1096">New this month</div>
              <div className="text-lg font-semibold text-blue-400" data-id="element-1097">
                +{summaryData.newUsersThisMonth}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1098">
          <div className="flex justify-between items-start mb-4" data-id="element-1099">
            <div className="p-2 rounded-lg bg-amber-500/20" data-id="element-1100">
              <TargetIcon size={20} className="text-amber-400" data-id="element-1101" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-blue-500/20 text-blue-400" data-id="element-1102">
              <PercentIcon size={12} className="mr-1" data-id="element-1103" />
              {summaryData.conversionRate}%
            </div>
          </div>
          <div className="mb-3" data-id="element-1104">
            <div className="text-sm text-slate-400 mb-1" data-id="element-1105">
              Lead Qualification
            </div>
            <div className="text-2xl font-bold text-white" data-id="element-1106">
              Average: {summaryData.averageScore}
            </div>
          </div>
          <div className="grid grid-cols-4 gap-1 text-center text-xs" data-id="element-1107">
            <div data-id="element-1108">
              <div className="bg-red-500/20 text-red-400 rounded-md py-1" data-id="element-1109">
                Hot
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1110">
                {summaryData.leadsByStatus.hot}
              </div>
            </div>
            <div data-id="element-1111">
              <div className="bg-amber-500/20 text-amber-400 rounded-md py-1" data-id="element-1112">
                Warm
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1113">
                {summaryData.leadsByStatus.warm}
              </div>
            </div>
            <div data-id="element-1114">
              <div className="bg-blue-500/20 text-blue-400 rounded-md py-1" data-id="element-1115">
                Cold
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1116">
                {summaryData.leadsByStatus.cold}
              </div>
            </div>
            <div data-id="element-1117">
              <div className="bg-slate-500/20 text-slate-400 rounded-md py-1" data-id="element-1118">
                N/C
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1119">
                {summaryData.leadsByStatus.unclassified || 0}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1120">
          <div className="flex justify-between items-start mb-4" data-id="element-1121">
            <div className="p-2 rounded-lg bg-purple-500/20" data-id="element-1122">
              <FileTextIcon size={20} className="text-purple-400" data-id="element-1123" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-green-500/20 text-green-400" data-id="element-1124">
              <TrendingUpIcon size={12} className="mr-1" data-id="element-1125" />
              +12%
            </div>
          </div>
          <div className="mb-3" data-id="element-1126">
            <div className="text-sm text-slate-400 mb-1" data-id="element-1127">Quote Requests</div>
            <div className="text-2xl font-bold text-white" data-id="element-1128">14 this month</div>
          </div>
          <div className="space-y-2" data-id="element-1129">
            <div data-id="element-1130">
              <div className="flex justify-between text-xs mb-1" data-id="element-1131">
                <span className="text-slate-400" data-id="element-1132">Conversion rate</span>
                <span className="text-white" data-id="element-1133">32%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1134">
                <div className="bg-purple-500 h-1.5 rounded-full" style={{
                width: '32%'
              }} data-id="element-1135"></div>
              </div>
            </div>
            <div data-id="element-1136">
              <div className="flex justify-between text-xs mb-1" data-id="element-1137">
                <span className="text-slate-400" data-id="element-1138">Response time</span>
                <span className="text-white" data-id="element-1139">1.2 days</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1140">
                <div className="bg-indigo-500 h-1.5 rounded-full" style={{
                width: '65%'
              }} data-id="element-1141"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1142">
          <div className="flex justify-between items-start mb-4" data-id="element-1143">
            <div className="p-2 rounded-lg bg-indigo-500/20" data-id="element-1144">
              <GlobeIcon size={20} className="text-indigo-400" data-id="element-1145" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-indigo-500/20 text-indigo-400" data-id="element-1146">
              <MapPinIcon size={12} className="mr-1" data-id="element-1147" />
              {summaryData.topRegion}
            </div>
          </div>
          <div className="mb-3" data-id="element-1148">
            <div className="text-sm text-slate-400 mb-1" data-id="element-1149">
              Regional Distribution
            </div>
            <div className="text-2xl font-bold text-white" data-id="element-1150">
              5 Active Regions
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-1151">
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1152">
              <div className="text-slate-400" data-id="element-1153">LATAM</div>
              <div className="text-white font-medium" data-id="element-1154">2 users</div>
            </div>
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1155">
              <div className="text-slate-400" data-id="element-1156">EUROPE</div>
              <div className="text-white font-medium" data-id="element-1157">1 user</div>
            </div>
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1158">
              <div className="text-slate-400" data-id="element-1159">MENA</div>
              <div className="text-white font-medium" data-id="element-1160">1 user</div>
            </div>
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1161">
              <div className="text-slate-400" data-id="element-1162">ANZ</div>
              <div className="text-white font-medium" data-id="element-1163">1 user</div>
            </div>
          </div>
        </div>
      </div>
      <DashboardCard data-id="element-1164">
        <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-1165">
          <h3 className="text-xl font-bold text-white mb-4 md:mb-0" data-id="element-1166">
            Public Users
          </h3>
          <div className="flex flex-wrap gap-3" data-id="element-1167">
            <div className="relative" data-id="element-1168">
              <input type="text" placeholder="Search users..." className="pl-9 pr-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-64" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1169" />
              <SearchIcon className="absolute left-3 top-2.5 text-slate-400" size={16} data-id="element-1170" />
            </div>
            {/* Filtros básicos siempre visibles */}
            <select className="appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedLeadStatus} onChange={e => setSelectedLeadStatus(e.target.value)} data-id="element-1171">
              <option value="all" data-id="element-1172">All Lead Status</option>
              <option value="new" data-id="element-1173">Warm Leads</option>
              <option value="qualified" data-id="element-1174">Hot Leads</option>
              <option value="disqualified" data-id="element-1175">Cold Leads</option>
              <option value="unclassified" data-id="element-1176">Unclassified</option>
            </select>
            <button className="p-2 rounded-lg bg-slate-800 border border-slate-700 text-slate-300 hover:bg-slate-700 flex items-center" onClick={() => setShowAdvancedFilters(!showAdvancedFilters)} data-id="element-1177">
              <SlidersIcon size={18} className="mr-1" data-id="element-1178" />
              Filters
              {showAdvancedFilters ? <ChevronUpIcon size={14} className="ml-1" data-id="element-1179" /> : <ChevronDownIcon size={14} className="ml-1" data-id="element-1180" />}
            </button>
            {filteredUsers.length !== publicUsers.length && <button className="p-2 rounded-lg bg-red-800/30 border border-red-700/30 text-red-300 hover:bg-red-800/50 flex items-center" onClick={handleResetFilters} data-id="element-1181">
                <FilterXIcon size={18} className="mr-1" data-id="element-1182" />
                Clear
              </button>}
          </div>
        </div>
        {/* Filtros avanzados (desplegables) */}
        {showAdvancedFilters && <div className="mb-6 p-4 bg-slate-800/50 rounded-lg border border-slate-700" data-id="element-1183">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1184">
              <div data-id="element-1185">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1186">
                  Region
                </label>
                <select className="w-full appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} data-id="element-1187">
                  <option value="all" data-id="element-1188">All regions</option>
                  <option value="EUROPE" data-id="element-1189">Europe</option>
                  <option value="AMERICA" data-id="element-1190">America</option>
                  <option value="LATAM" data-id="element-1191">LATAM</option>
                  <option value="MENA" data-id="element-1192">MENA</option>
                  <option value="ANZ" data-id="element-1193">ANZ</option>
                  <option value="AFRICA" data-id="element-1194">Africa</option>
                </select>
              </div>
              <div data-id="element-1195">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1196">
                  Country
                </label>
                <select className="w-full appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedCountry} onChange={e => setSelectedCountry(e.target.value)} data-id="element-1197">
                  <option value="all" data-id="element-1198">All countries</option>
                  {uniqueCountries.map(country => <option key={country} value={country} data-id="element-1199">
                      {country}
                    </option>)}
                </select>
              </div>
              <div data-id="element-1200">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1201">
                  Activity status
                </label>
                <select className="w-full appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedActivity} onChange={e => setSelectedActivity(e.target.value)} data-id="element-1202">
                  <option value="all" data-id="element-1203">All</option>
                  <option value="active" data-id="element-1204">Active</option>
                  <option value="inactive" data-id="element-1205">Inactive</option>
                </select>
              </div>
              <div data-id="element-1206">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1207">
                  Score range
                </label>
                <div className="flex items-center space-x-2" data-id="element-1208">
                  <input type="number" min="0" max="100" value={scoreRange[0]} onChange={e => setScoreRange([parseInt(e.target.value), scoreRange[1]])} className="w-20 bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1209" />
                  <span className="text-slate-400" data-id="element-1210">to</span>
                  <input type="number" min="0" max="100" value={scoreRange[1]} onChange={e => setScoreRange([scoreRange[0], parseInt(e.target.value)])} className="w-20 bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1211" />
                </div>
              </div>
              <div data-id="element-1212">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1213">
                  Registration date
                </label>
                <div className="flex items-center space-x-2" data-id="element-1214">
                  <div className="relative flex-1" data-id="element-1215">
                    <input type="date" value={dateRange.start || ''} onChange={e => setDateRange({
                  ...dateRange,
                  start: e.target.value
                })} className="w-full bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1216" />
                    <CalendarIcon size={16} className="absolute right-3 top-3 text-slate-400 pointer-events-none" data-id="element-1217" />
                  </div>
                  <span className="text-slate-400" data-id="element-1218">to</span>
                  <div className="relative flex-1" data-id="element-1219">
                    <input type="date" value={dateRange.end || ''} onChange={e => setDateRange({
                  ...dateRange,
                  end: e.target.value
                })} className="w-full bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1220" />
                    <CalendarIcon size={16} className="absolute right-3 top-3 text-slate-400 pointer-events-none" data-id="element-1221" />
                  </div>
                </div>
              </div>
              <div className="flex items-end" data-id="element-1222">
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={() => {}} data-id="element-1223">
                  Apply filters
                </button>
              </div>
            </div>
          </div>}
        <div className="overflow-x-auto" data-id="element-1224">
          <table className="w-full" data-id="element-1225">
            <thead data-id="element-1226">
              <tr className="text-left border-b border-slate-700" data-id="element-1227">
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('name')} data-id="element-1228">
                  <div className="flex items-center" data-id="element-1229">
                    User
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-1230">
                      {sortField === 'name' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1231" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1232" /> : <ArrowUpDownIcon size={14} data-id="element-1233" />}
                    </button>
                  </div>
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm" data-id="element-1234">
                  Location
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('lastActive')} data-id="element-1235">
                  <div className="flex items-center" data-id="element-1236">
                    Activity
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-1237">
                      {sortField === 'lastActive' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1238" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1239" /> : <ArrowUpDownIcon size={14} data-id="element-1240" />}
                    </button>
                  </div>
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('designs')} data-id="element-1241">
                  <div className="flex items-center" data-id="element-1242">
                    Designs
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-1243">
                      {sortField === 'designs' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1244" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1245" /> : <ArrowUpDownIcon size={14} data-id="element-1246" />}
                    </button>
                  </div>
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('score')} data-id="element-1247">
                  <div className="flex items-center" data-id="element-1248">
                    Score
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" title="Sort by score" data-id="element-1249">
                      {sortField === 'score' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1250" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1251" /> : <ArrowUpDownIcon size={14} data-id="element-1252" />}
                    </button>
                    <button className="ml-1 text-slate-400 hover:text-blue-400 transition-colors" title="What is Lead Score?" onClick={e => {
                    e.stopPropagation();
                    toggleScoreInfo('info');
                  }} data-id="element-1253">
                      <InfoIcon size={14} data-id="element-1254" />
                    </button>
                  </div>
                  {showScoreInfo === 'info' && <div className="absolute z-10 mt-2 bg-slate-800 border border-slate-700 rounded-lg shadow-xl p-4 w-80 left-1/2 transform -translate-x-1/2" data-id="element-1255">
                      <div className="flex justify-between items-start mb-2" data-id="element-1256">
                        <h4 className="text-white font-medium" data-id="element-1257">
                          Lead Scoring System
                        </h4>
                        <button className="text-slate-400 hover:text-white" onClick={() => setShowScoreInfo(null)} data-id="element-1258">
                          <XIcon size={14} data-id="element-1259" />
                        </button>
                      </div>
                      <div className="space-y-3" data-id="element-1260">
                        <p className="text-slate-300 text-sm" data-id="element-1261">
                          The lead score (0-100) evaluates the conversion
                          potential and commercial value of each user based on
                          multiple factors:
                        </p>
                        <div className="space-y-2 mt-2" data-id="element-1262">
                          <div className="flex items-start" data-id="element-1263">
                            <ActivityIcon size={14} className="mt-0.5 mr-2 text-blue-400 flex-shrink-0" data-id="element-1264" />
                            <div data-id="element-1265">
                              <div className="text-sm font-medium text-white" data-id="element-1266">
                                Platform Activity (25%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1267">
                                Login frequency, session time, interactions with
                                key tools
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1268">
                            <MapPinIcon size={14} className="mt-0.5 mr-2 text-emerald-400 flex-shrink-0" data-id="element-1269" />
                            <div data-id="element-1270">
                              <div className="text-sm font-medium text-white" data-id="element-1271">
                                Geographic Location (15%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1272">
                                Market potential in the region, distributor
                                presence
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1273">
                            <FileTextIcon size={14} className="mt-0.5 mr-2 text-amber-400 flex-shrink-0" data-id="element-1274" />
                            <div data-id="element-1275">
                              <div className="text-sm font-medium text-white" data-id="element-1276">
                                Quote Requests (20%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1277">
                                Number and frequency of requested quotes
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1278">
                            <BriefcaseIcon size={14} className="mt-0.5 mr-2 text-indigo-400 flex-shrink-0" data-id="element-1279" />
                            <div data-id="element-1280">
                              <div className="text-sm font-medium text-white" data-id="element-1281">
                                Professional Profile (15%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1282">
                                Company type, sector, estimated size
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1283">
                            <BarChart2Icon size={14} className="mt-0.5 mr-2 text-purple-400 flex-shrink-0" data-id="element-1284" />
                            <div data-id="element-1285">
                              <div className="text-sm font-medium text-white" data-id="element-1286">
                                Design Complexity (25%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1287">
                                Project sophistication, size and technical
                                specifications
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pt-2 border-t border-slate-700" data-id="element-1288">
                          <div className="flex items-center justify-between" data-id="element-1289">
                            <div className="text-sm text-blue-300" data-id="element-1290">
                              Automatic classification:
                            </div>
                          </div>
                          <div className="grid grid-cols-3 gap-2 mt-2 text-xs text-center" data-id="element-1291">
                            <div className="bg-red-500/20 text-red-400 rounded p-1" data-id="element-1292">
                              Hot (80-100)
                            </div>
                            <div className="bg-amber-500/20 text-amber-400 rounded p-1" data-id="element-1293">
                              Warm (60-79)
                            </div>
                            <div className="bg-blue-500/20 text-blue-400 rounded p-1" data-id="element-1294">
                              Cold (0-59)
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm" data-id="element-1295">
                  Status
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm text-right" data-id="element-1296">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1297">
              {sortedUsers.map(user => <tr key={user.id} className="border-b border-slate-800 hover:bg-slate-800/50" data-id="element-1298">
                  <td className="py-4" data-id="element-1299">
                    <div className="flex items-center" data-id="element-1300">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-3" data-id="element-1301">
                        <span className="text-white text-xs font-bold" data-id="element-1302">
                          {user.name.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <div data-id="element-1303">
                        <div className="text-white font-medium" data-id="element-1304">
                          {user.name}
                        </div>
                        <div className="text-slate-400 text-sm" data-id="element-1305">
                          {user.email}
                        </div>
                        {user.company && <div className="text-slate-500 text-xs" data-id="element-1306">
                            {user.company}
                          </div>}
                      </div>
                    </div>
                  </td>
                  <td className="py-4" data-id="element-1307">
                    <div className="text-white flex items-center" data-id="element-1308">
                      <GlobeIcon size={14} className="mr-1 text-slate-400" data-id="element-1309" />
                      {user.country}
                    </div>
                    <div className="text-slate-400 text-sm flex items-center" data-id="element-1310">
                      <MapPinIcon size={12} className="mr-1" data-id="element-1311" />
                      {user.region}
                    </div>
                  </td>
                  <td className="py-4" data-id="element-1312">
                    <div className="text-white flex items-center" data-id="element-1313">
                      <CalendarIcon size={14} className="mr-1 text-slate-400" data-id="element-1314" />
                      {formatDate(user.registrationDate)}
                    </div>
                    <div className="text-slate-400 text-sm flex items-center" data-id="element-1315">
                      <ClockIcon size={12} className="mr-1" data-id="element-1316" />
                      Last: {formatDate(user.lastActive)}
                    </div>
                  </td>
                  <td className="py-4" data-id="element-1317">
                    <div className="text-white" data-id="element-1318">{user.designs}</div>
                    <div className="text-slate-400 text-sm" data-id="element-1319">
                      {user.quotes} quotes
                    </div>
                  </td>
                  <td className="py-4 relative" data-id="element-1320">
                    <div onClick={() => toggleScoreInfo(user.id)} className="cursor-pointer" data-id="element-1321">
                      <LeadScoreBadge score={user.score} data-id="element-1322" />
                    </div>
                    {showScoreInfo === user.id && <div className="absolute z-10 mt-2 bg-slate-800 border border-slate-700 rounded-lg shadow-xl p-4 w-72 left-1/2 transform -translate-x-1/2" data-id="element-1323">
                        <div className="flex justify-between items-start mb-3" data-id="element-1324">
                          <h4 className="text-white font-medium" data-id="element-1325">
                            Score Breakdown
                          </h4>
                          <button className="text-slate-400 hover:text-white" onClick={() => setShowScoreInfo(null)} data-id="element-1326">
                            <XIcon size={14} data-id="element-1327" />
                          </button>
                        </div>
                        <div className="space-y-3" data-id="element-1328">
                          <div data-id="element-1329">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1330">
                              <span className="text-slate-300" data-id="element-1331">Engagement</span>
                              <span className="text-white" data-id="element-1332">
                                {user.scoreComponents.engagement}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1333">
                              <div className="bg-blue-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.engagement}%`
                        }} data-id="element-1334"></div>
                            </div>
                          </div>
                          <div data-id="element-1335">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1336">
                              <span className="text-slate-300" data-id="element-1337">Activity</span>
                              <span className="text-white" data-id="element-1338">
                                {user.scoreComponents.activity}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1339">
                              <div className="bg-indigo-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.activity}%`
                        }} data-id="element-1340"></div>
                            </div>
                          </div>
                          <div data-id="element-1341">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1342">
                              <span className="text-slate-300" data-id="element-1343">
                                Design Quality
                              </span>
                              <span className="text-white" data-id="element-1344">
                                {user.scoreComponents.designQuality}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1345">
                              <div className="bg-emerald-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.designQuality}%`
                        }} data-id="element-1346"></div>
                            </div>
                          </div>
                          <div data-id="element-1347">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1348">
                              <span className="text-slate-300" data-id="element-1349">
                                Quote Requests
                              </span>
                              <span className="text-white" data-id="element-1350">
                                {user.scoreComponents.quoteRequests}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1351">
                              <div className="bg-amber-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.quoteRequests}%`
                        }} data-id="element-1352"></div>
                            </div>
                          </div>
                          <div data-id="element-1353">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1354">
                              <span className="text-slate-300" data-id="element-1355">
                                Market Potential
                              </span>
                              <span className="text-white" data-id="element-1356">
                                {user.scoreComponents.marketPotential}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1357">
                              <div className="bg-purple-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.marketPotential}%`
                        }} data-id="element-1358"></div>
                            </div>
                          </div>
                          <div className="pt-2 border-t border-slate-700" data-id="element-1359">
                            <div className="flex justify-between font-medium" data-id="element-1360">
                              <span className="text-blue-300" data-id="element-1361">Total Score</span>
                              <span className="text-white" data-id="element-1362">{user.score}</span>
                            </div>
                          </div>
                        </div>
                      </div>}
                  </td>
                  <td className="py-4" data-id="element-1363">
                    {renderLeadStatusBadge(user.leadStatus)}
                  </td>
                  <td className="py-4 text-right" data-id="element-1364">
                    <div className="flex justify-end space-x-2" data-id="element-1365">
                      <button className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 hover:bg-blue-500/30" title="Assign to Dealer" data-id="element-1366">
                        <UserCheckIcon size={16} data-id="element-1367" />
                      </button>
                      <button className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 hover:bg-blue-500/30" title="Contact User" data-id="element-1368">
                        <MailIcon size={16} data-id="element-1369" />
                      </button>
                      <button className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 hover:bg-blue-500/30" title="View Details" onClick={() => handleViewDetails(user)} data-id="element-1370">
                        <EyeIcon size={16} data-id="element-1371" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {sortedUsers.length === 0 && <div className="text-center py-12 text-slate-400" data-id="element-1372">
              No users found matching your search criteria
            </div>}
        </div>
      </DashboardCard>
      {/* User Details Modal */}
      {showUserDetails && selectedUser && <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" data-id="element-1373">
          <div className="bg-gradient-to-br from-slate-900 to-blue-900 rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-auto" data-id="element-1374">
            <div className="p-6 border-b border-slate-700 flex justify-between items-start sticky top-0 bg-gradient-to-r from-slate-900 to-blue-900 z-10" data-id="element-1375">
              <div className="flex items-center" data-id="element-1376">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-4" data-id="element-1377">
                  <span className="text-white text-lg font-bold" data-id="element-1378">
                    {selectedUser.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div data-id="element-1379">
                  <h2 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-1380">
                    {selectedUser.name}
                    <LeadScoreBadge score={selectedUser.score} data-id="element-1381" />
                    {renderLeadStatusBadge(selectedUser.leadStatus)}
                  </h2>
                  <div className="text-slate-300 flex items-center" data-id="element-1382">
                    <MailIcon size={14} className="mr-1 text-slate-400" data-id="element-1383" />
                    {selectedUser.email}
                  </div>
                  {selectedUser.company && <div className="text-slate-400 text-sm mt-1" data-id="element-1384">
                      {selectedUser.company}
                    </div>}
                </div>
              </div>
              <button onClick={handleCloseDetails} className="p-2 rounded-full bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-white transition-colors" data-id="element-1385">
                <XIcon size={20} data-id="element-1386" />
              </button>
            </div>
            {/* ... resto del contenido del modal ... */}
            <div className="p-6" data-id="element-1387">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1388">
                {/* User Activity Section - Moved to the top */}
                <div className="space-y-6 md:col-span-2" data-id="element-1389">
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1390">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1391">
                      <ActivityIcon size={18} className="mr-2 text-blue-400" data-id="element-1392" />
                      User Activity
                    </h3>
                    {/* Activity Timeline */}
                    <div className="mb-6" data-id="element-1393">
                      <h4 className="text-white font-medium mb-3" data-id="element-1394">
                        Recent Activity History
                      </h4>
                      <div className="space-y-4" data-id="element-1395">
                        <div className="flex" data-id="element-1396">
                          <div className="mr-3 relative" data-id="element-1397">
                            <div className="w-8 h-8 rounded-full bg-blue-500/30 flex items-center justify-center" data-id="element-1398">
                              <MousePointerIcon size={14} className="text-blue-300" data-id="element-1399" />
                            </div>
                            <div className="absolute top-8 bottom-0 left-1/2 w-0.5 bg-blue-500/20" data-id="element-1400"></div>
                          </div>
                          <div className="flex-1 pb-4" data-id="element-1401">
                            <div className="flex justify-between" data-id="element-1402">
                              <div className="text-white font-medium" data-id="element-1403">
                                Design Session
                              </div>
                              <div className="text-slate-400 text-sm" data-id="element-1404">
                                Today, 10:45 AM
                              </div>
                            </div>
                            <div className="text-slate-300 text-sm" data-id="element-1405">
                              Created a new center pivot system design
                            </div>
                            <div className="text-slate-400 text-xs mt-1" data-id="element-1406">
                              Duration: 32 minutes
                            </div>
                          </div>
                        </div>
                        <div className="flex" data-id="element-1407">
                          <div className="mr-3 relative" data-id="element-1408">
                            <div className="w-8 h-8 rounded-full bg-emerald-500/30 flex items-center justify-center" data-id="element-1409">
                              <FileTextIcon size={14} className="text-emerald-300" data-id="element-1410" />
                            </div>
                            <div className="absolute top-8 bottom-0 left-1/2 w-0.5 bg-blue-500/20" data-id="element-1411"></div>
                          </div>
                          <div className="flex-1 pb-4" data-id="element-1412">
                            <div className="flex justify-between" data-id="element-1413">
                              <div className="text-white font-medium" data-id="element-1414">
                                Requested Quote
                              </div>
                              <div className="text-slate-400 text-sm" data-id="element-1415">
                                Yesterday, 15:30 PM
                              </div>
                            </div>
                            <div className="text-slate-300 text-sm" data-id="element-1416">
                              Requested a quote for an 8-tower system
                            </div>
                            <div className="text-slate-400 text-xs mt-1" data-id="element-1417">
                              Quote ID: Q-2025-0734
                            </div>
                          </div>
                        </div>
                        <div className="flex" data-id="element-1418">
                          <div className="mr-3 relative" data-id="element-1419">
                            <div className="w-8 h-8 rounded-full bg-amber-500/30 flex items-center justify-center" data-id="element-1420">
                              <ExternalLinkIcon size={14} className="text-amber-300" data-id="element-1421" />
                            </div>
                          </div>
                          <div className="flex-1" data-id="element-1422">
                            <div className="flex justify-between" data-id="element-1423">
                              <div className="text-white font-medium" data-id="element-1424">
                                Visited Product Gallery
                              </div>
                              <div className="text-slate-400 text-sm" data-id="element-1425">
                                3 days ago
                              </div>
                            </div>
                            <div className="text-slate-300 text-sm" data-id="element-1426">
                              Reviewed pivot irrigation system specifications
                            </div>
                            <div className="text-slate-400 text-xs mt-1" data-id="element-1427">
                              Duration: 18 minutes
                            </div>
                          </div>
                        </div>
                      </div>
                      <button className="mt-3 text-blue-400 hover:text-blue-300 text-sm flex items-center" data-id="element-1428">
                        View complete history
                        <ChevronRightIcon size={14} className="ml-1" data-id="element-1429" />
                      </button>
                    </div>
                    {/* Activity Metrics */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5" data-id="element-1430">
                      <div className="bg-blue-900/30 p-3 rounded-lg text-center" data-id="element-1431">
                        <div className="text-2xl font-bold text-white" data-id="element-1432">
                          {selectedUser.usageStats.lastWeek}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-1433">
                          Sessions last 7 days
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-3 rounded-lg text-center" data-id="element-1434">
                        <div className="text-2xl font-bold text-white" data-id="element-1435">
                          {selectedUser.usageStats.lastMonth}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-1436">
                          Sessions last 30 days
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-3 rounded-lg text-center" data-id="element-1437">
                        <div className="text-2xl font-bold text-white" data-id="element-1438">
                          {selectedUser.usageStats.total}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-1439">
                          Total sessions
                        </div>
                      </div>
                    </div>
                    {/* Weekly Usage Pattern */}
                    <div className="mb-5" data-id="element-1440">
                      <div className="text-white font-medium mb-3" data-id="element-1441">
                        Weekly Usage Pattern
                      </div>
                      <div className="flex justify-between bg-slate-800/70 p-3 rounded-lg" data-id="element-1442">
                        {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((day, index) => <div key={index} className="text-center" data-id="element-1443">
                              <div className="text-xs text-slate-400 mb-1" data-id="element-1444">
                                {day}
                              </div>
                              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${selectedUser.usageDays[index] ? 'bg-blue-500/30 text-blue-300' : 'bg-slate-700/30 text-slate-500'}`} data-id="element-1445">
                                {selectedUser.usageDays[index] ? <CheckIcon size={12} data-id="element-1446" /> : '-'}
                              </div>
                            </div>)}
                      </div>
                      <div className="text-xs text-slate-400 mt-2" data-id="element-1447">
                        User shows higher activity during weekdays, with peaks
                        on Mondays and Thursdays.
                      </div>
                    </div>
                    {/* Score Breakdown - UPDATED */}
                    <div className="space-y-4" data-id="element-1448">
                      <h4 className="text-white font-medium mb-2" data-id="element-1449">
                        Score Breakdown
                      </h4>
                      <div className="space-y-5" data-id="element-1450">
                        {/* App Activity */}
                        <div data-id="element-1451">
                          <div className="flex justify-between mb-1" data-id="element-1452">
                            <div className="text-slate-300 flex items-center" data-id="element-1453">
                              <ActivityIcon size={14} className="mr-1 text-blue-400" data-id="element-1454" />
                              App Activity
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('activity')} data-id="element-1455">
                                <HelpCircleIcon size={14} data-id="element-1456" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1457">
                              {selectedUser.scoreComponents.engagement}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1458">
                            <div className="bg-blue-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.engagement}%`
                        }} data-id="element-1459"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1460">
                            Evaluates the frequency and depth of system usage.
                          </div>
                          {showLongDescription === 'activity' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1461">
                              Includes how many times they've logged in, how
                              many designs they've created, and whether they've
                              interacted with key features like quotes or
                              orders.
                            </div>}
                        </div>
                        {/* Time on Platform */}
                        <div data-id="element-1462">
                          <div className="flex justify-between mb-1" data-id="element-1463">
                            <div className="text-slate-300 flex items-center" data-id="element-1464">
                              <TimerIcon size={14} className="mr-1 text-indigo-400" data-id="element-1465" />
                              Time on Platform
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('time')} data-id="element-1466">
                                <HelpCircleIcon size={14} data-id="element-1467" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1468">
                              {selectedUser.scoreComponents.activity}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1469">
                            <div className="bg-indigo-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.activity}%`
                        }} data-id="element-1470"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1471">
                            Measures how long they've been active since
                            registration.
                          </div>
                          {showLongDescription === 'time' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1472">
                              A lead with several weeks or months of consistent
                              activity is considered more engaged than one who
                              just registered.
                            </div>}
                        </div>
                        {/* Geographic Location */}
                        <div data-id="element-1473">
                          <div className="flex justify-between mb-1" data-id="element-1474">
                            <div className="text-slate-300 flex items-center" data-id="element-1475">
                              <MapPinIcon size={14} className="mr-1 text-emerald-400" data-id="element-1476" />
                              Geographic Location
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('location')} data-id="element-1477">
                                <HelpCircleIcon size={14} data-id="element-1478" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1479">
                              {selectedUser.scoreComponents.designQuality}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1480">
                            <div className="bg-emerald-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.designQuality}%`
                        }} data-id="element-1481"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1482">
                            Considers the user's country or region based on
                            sales potential.
                          </div>
                          {showLongDescription === 'location' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1483">
                              Some regions have higher purchase history or
                              active commercial strategies.
                            </div>}
                        </div>
                        {/* Market Potential */}
                        <div data-id="element-1484">
                          <div className="flex justify-between mb-1" data-id="element-1485">
                            <div className="text-slate-300 flex items-center" data-id="element-1486">
                              <GlobeIcon size={14} className="mr-1 text-purple-400" data-id="element-1487" />
                              Market Potential
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('market')} data-id="element-1488">
                                <HelpCircleIcon size={14} data-id="element-1489" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1490">
                              {selectedUser.scoreComponents.marketPotential}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1491">
                            <div className="bg-purple-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.marketPotential}%`
                        }} data-id="element-1492"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1493">
                            Evaluation of the commercial value of the region or
                            country where the lead is located.
                          </div>
                          {showLongDescription === 'market' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1494">
                              Market potential represents the strategic
                              opportunity to generate sales in the lead's
                              geographic area. This assessment is based on
                              factors such as local agricultural investment,
                              irrigation technology adoption, subsidy presence,
                              regional sales history, and competition in the
                              area. Higher market potential indicates a higher
                              probability of conversion and greater long-term
                              value for the company.
                            </div>}
                        </div>
                        {/* Quote Requests */}
                        <div data-id="element-1495">
                          <div className="flex justify-between mb-1" data-id="element-1496">
                            <div className="text-slate-300 flex items-center" data-id="element-1497">
                              <ClipboardIcon size={14} className="mr-1 text-amber-400" data-id="element-1498" />
                              Quote Requests
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('quotes')} data-id="element-1499">
                                <HelpCircleIcon size={14} data-id="element-1500" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1501">
                              {selectedUser.scoreComponents.quoteRequests}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1502">
                            <div className="bg-amber-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.quoteRequests}%`
                        }} data-id="element-1503"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1504">
                            Request sent by a public user interested in
                            obtaining prices.
                          </div>
                          {showLongDescription === 'quotes' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1505">
                              This is a formal request made through the platform
                              by a public user—i.e., not yet assigned to any
                              dealer or classified as a customer—who has
                              designed a system or project and wants to receive
                              a quote. This type of interaction represents a
                              clear purchase intention and constitutes a
                              valuable commercial lead. It can be the starting
                              point for contacting, qualifying, and converting
                              the user into a customer, either by assigning them
                              to a dealer or managing them directly from a
                              Business Unit.
                            </div>}
                        </div>
                        <div className="pt-4 border-t border-slate-700 flex items-center justify-between" data-id="element-1506">
                          <div className="text-lg text-blue-300 font-medium flex items-center" data-id="element-1507">
                            <PieChartIcon size={18} className="mr-2" data-id="element-1508" />
                            Total Score
                          </div>
                          <div className="text-2xl font-bold text-white" data-id="element-1509">
                            {selectedUser.score}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ... resto de las secciones del modal ... */}
                {/* User Information - Moved down */}
                <div className="space-y-6" data-id="element-1510">
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1511">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1512">
                      <UserIcon size={18} className="mr-2 text-blue-400" data-id="element-1513" />
                      User Information
                    </h3>
                    <div className="space-y-4" data-id="element-1514">
                      <div className="flex justify-between" data-id="element-1515">
                        <div className="text-slate-400" data-id="element-1516">Email</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1517">
                          <MailIcon size={14} className="mr-1 text-blue-400" data-id="element-1518" />
                          {selectedUser.email}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1519">
                        <div className="text-slate-400" data-id="element-1520">Phone</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1521">
                          <PhoneIcon size={14} className="mr-1 text-blue-400" data-id="element-1522" />
                          {selectedUser.phone}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1523">
                        <div className="text-slate-400" data-id="element-1524">Registration Date</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1525">
                          <CalendarIcon size={14} className="mr-1 text-blue-400" data-id="element-1526" />
                          {formatDate(selectedUser.registrationDate)}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1527">
                        <div className="text-slate-400" data-id="element-1528">Country & Region</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1529">
                          <GlobeIcon size={14} className="mr-1 text-blue-400" data-id="element-1530" />
                          {selectedUser.country} ({selectedUser.region})
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1531">
                        <div className="text-slate-400" data-id="element-1532">Designs Created</div>
                        <div className="text-white font-medium" data-id="element-1533">
                          {selectedUser.designs}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1534">
                        <div className="text-slate-400" data-id="element-1535">Last Activity</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1536">
                          <ClockIcon size={14} className="mr-1 text-blue-400" data-id="element-1537" />
                          {formatDate(selectedUser.lastActive)}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1538">
                        <div className="text-slate-400" data-id="element-1539">Usage Frequency</div>
                        <div className="text-white font-medium" data-id="element-1540">
                          {selectedUser.usageFrequency}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1541">
                        <div className="text-slate-400" data-id="element-1542">Lead Score</div>
                        <LeadScoreBadge score={selectedUser.score} data-id="element-1543" />
                      </div>
                      <div className="flex justify-between" data-id="element-1544">
                        <div className="text-slate-400" data-id="element-1545">Lead Status</div>
                        <div className="text-white font-medium" data-id="element-1546">
                          {renderLeadStatusBadge(selectedUser.leadStatus)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Actions Panel */}
                <div className="space-y-6" data-id="element-1547">
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1548">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1549">
                      <CheckCircleIcon size={18} className="mr-2 text-blue-400" data-id="element-1550" />
                      Lead Qualification
                    </h3>
                    <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1551">
                      <button onClick={() => handleQualifyLead('qualified')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'qualified' ? 'bg-red-600/40 text-red-300 cursor-not-allowed' : 'bg-red-600/20 hover:bg-red-600/30 text-red-400'}`} disabled={selectedUser.leadStatus === 'qualified'} onMouseEnter={() => setTooltipVisible('hot-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1552">
                        <div size={16} className="mr-2" data-id="element-1553" />
                        {selectedUser.leadStatus === 'qualified' ? 'Hot lead' : 'Mark as Hot'}
                        {tooltipVisible === 'hot-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1554">
                            Ready to purchase
                          </div>}
                      </button>
                      <button onClick={() => handleQualifyLead('new')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'new' ? 'bg-amber-600/40 text-amber-300 cursor-not-allowed' : 'bg-amber-600/20 hover:bg-amber-600/30 text-amber-400'}`} disabled={selectedUser.leadStatus === 'new'} onMouseEnter={() => setTooltipVisible('warm-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1555">
                        <ThermometerIcon size={16} className="mr-2" data-id="element-1556" />
                        {selectedUser.leadStatus === 'new' ? 'Warm lead' : 'Mark as Warm'}
                        {tooltipVisible === 'warm-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1557">
                            Interested, needs follow-up
                          </div>}
                      </button>
                      <button onClick={() => handleQualifyLead('disqualified')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'disqualified' ? 'bg-blue-600/40 text-blue-300 cursor-not-allowed' : 'bg-blue-600/20 hover:bg-blue-600/30 text-blue-400'}`} disabled={selectedUser.leadStatus === 'disqualified'} onMouseEnter={() => setTooltipVisible('cold-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1558">
                        <SnowflakeIcon size={16} className="mr-2" data-id="element-1559" />
                        {selectedUser.leadStatus === 'disqualified' ? 'Cold lead' : 'Mark as Cold'}
                        {tooltipVisible === 'cold-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1560">
                            Low activity or intention
                          </div>}
                      </button>
                      <button onClick={() => handleQualifyLead('unclassified')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'unclassified' ? 'bg-slate-600/40 text-slate-300 cursor-not-allowed' : 'bg-slate-600/20 hover:bg-slate-600/30 text-slate-400'}`} disabled={selectedUser.leadStatus === 'unclassified'} onMouseEnter={() => setTooltipVisible('unclassified-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1561">
                        <BanIcon size={16} className="mr-2" data-id="element-1562" />
                        {selectedUser.leadStatus === 'unclassified' ? 'Unclassified' : 'Unclassify'}
                        {tooltipVisible === 'unclassified-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1563">
                            Remove lead classification
                          </div>}
                      </button>
                    </div>
                    <div className="space-y-2 mt-4" data-id="element-1564">
                      <div className="text-slate-400 text-sm mb-2" data-id="element-1565">Tags:</div>
                      {selectedUser.tags.map((tag, index) => <div key={index} className="inline-flex items-center bg-blue-900/30 text-blue-300 px-2 py-1 rounded-md text-xs mr-2" data-id="element-1566">
                          <TagIcon size={12} className="mr-1" data-id="element-1567" />
                          {tag}
                        </div>)}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1568">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1569">
                      <ArrowRightIcon size={18} className="mr-2 text-blue-400" data-id="element-1570" />
                      Suggested Actions
                    </h3>
                    <div className="space-y-4" data-id="element-1571">
                      <div className="bg-blue-900/30 p-4 rounded-lg hover:bg-blue-800/30 transition-colors cursor-pointer" data-id="element-1572">
                        <div className="flex items-start" data-id="element-1573">
                          <div className="p-2 rounded-lg bg-blue-500/20 mr-3" data-id="element-1574">
                            <UserCheckIcon size={16} className="text-blue-400" data-id="element-1575" />
                          </div>
                          <div className="flex-1" data-id="element-1576">
                            <h4 className="text-white font-medium" data-id="element-1577">
                              Assign to Distributor
                            </h4>
                            <p className="text-slate-400 text-sm mt-1" data-id="element-1578">
                              Connect this lead with the appropriate distributor
                              in their region
                            </p>
                          </div>
                          <ChevronRightIcon size={16} className="text-slate-400" data-id="element-1579" />
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-4 rounded-lg hover:bg-blue-800/30 transition-colors cursor-pointer" data-id="element-1580">
                        <div className="flex items-start" data-id="element-1581">
                          <div className="p-2 rounded-lg bg-emerald-500/20 mr-3" data-id="element-1582">
                            <MailIcon size={16} className="text-emerald-400" data-id="element-1583" />
                          </div>
                          <div className="flex-1" data-id="element-1584">
                            <h4 className="text-white font-medium" data-id="element-1585">
                              Contact by Email
                            </h4>
                            <p className="text-slate-400 text-sm mt-1" data-id="element-1586">
                              Send a personalized email to interact with this
                              lead
                            </p>
                          </div>
                          <ChevronRightIcon size={16} className="text-slate-400" data-id="element-1587" />
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-4 rounded-lg hover:bg-blue-800/30 transition-colors cursor-pointer" data-id="element-1588">
                        <div className="flex items-start" data-id="element-1589">
                          <div className="p-2 rounded-lg bg-amber-500/20 mr-3" data-id="element-1590">
                            <UserPlusIcon size={16} className="text-amber-400" data-id="element-1591" />
                          </div>
                          <div className="flex-1" data-id="element-1592">
                            <h4 className="text-white font-medium" data-id="element-1593">
                              Convert to Customer
                            </h4>
                            <p className="text-slate-400 text-sm mt-1" data-id="element-1594">
                              Update this lead to customer status
                            </p>
                          </div>
                          <ChevronRightIcon size={16} className="text-slate-400" data-id="element-1595" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1596">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1597">
                      <FileTextIcon size={18} className="mr-2 text-blue-400" data-id="element-1598" />
                      Notes
                    </h3>
                    <div className="bg-slate-900/50 p-3 rounded-lg text-slate-300 text-sm mb-4" data-id="element-1599">
                      {selectedUser.notes || 'No notes available for this lead.'}
                    </div>
                    <div className="flex" data-id="element-1600">
                      <input type="text" placeholder="Add a note..." className="flex-1 bg-slate-800 border border-slate-700 rounded-l-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1601" />
                      <button className="bg-blue-600 text-white px-4 py-2 rounded-r-lg hover:bg-blue-700 transition-colors" data-id="element-1602">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-slate-700 flex justify-between sticky bottom-0 bg-gradient-to-r from-slate-900 to-blue-900" data-id="element-1603">
              <button onClick={handleCloseDetails} className="px-4 py-2 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 transition-colors" data-id="element-1604">
                Close
              </button>
              <div className="flex space-x-3" data-id="element-1605">
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center" data-id="element-1606">
                  <PencilIcon size={16} className="mr-2" data-id="element-1607" />
                  Edit User
                </button>
                <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors flex items-center" data-id="element-1608">
                  <StarIcon size={16} className="mr-2" data-id="element-1609" />
                  Mark as Priority
                </button>
              </div>
            </div>
          </div>
        </div>}
    </>;
}